module.exports = __webpack_public_path__ + "img/radar.36c65c1c.png";